import { FocusMonitor } from '@angular/cdk/a11y';
import {
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    ElementRef,
    Input,
    OnDestroy,
    ViewEncapsulation,
} from '@angular/core';
import { ThemePalette } from '@angular/material/core';
import { MatStepHeader, MatStepperIntl } from '@angular/material/stepper';

@Component({
    selector: 'aum-step-header',
    templateUrl: 'aum-step-header.html',
    styleUrls: ['aum-step-header.scss'],
    host: {
        class: 'mat-step-header',
        role: 'tab',
    },
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AumStepHeader extends MatStepHeader implements OnDestroy {
    _circularPercentage: number = 0;
    override color: ThemePalette = 'primary';
    mode = 'determinate';

    @Input() set circularPercentage(circularPercentage: number) {
        this._circularPercentage = circularPercentage;
    }

    constructor(
        public override _intl: MatStepperIntl,
        _focusMonitor: FocusMonitor,
        _elementRef: ElementRef<HTMLElement>,
        changeDetectorRef: ChangeDetectorRef,
    ) {
        super(_intl, _focusMonitor, _elementRef, changeDetectorRef);
    }
}
